import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { closeModal } from "reducers/Modal";
import { Button, Modal } from "rhombus-react";

import "./ImportVersionsErrorModal.css";

export default function ImportVersionsErrorModal({ filename, errors, title }) {
	const dispatch = useDispatch();

	function onClose() {
		dispatch(closeModal());
	}

	function renderContent() {
		const columnHeadings = [
			{ heading:"Error Message" }
		];
		const headingRow = columnHeadings.map((col) => {
			return (
				<th
					className={`error-col`}
					scope="col"
					key={col.heading}
				>
					{col.heading}
				</th>
			);
		});

		let displayErrors = [...errors];

		// Safe guard against an api response that does not return a proper error
		if (displayErrors.length === 0) {
			displayErrors = ["An unknown error has occurred"];
		}
		const errorRows = displayErrors.map(err => (
			<tr key={`import-error-${Math.random()}`} className="import-error-row">
				<td>
					<span>{err}</span>
				</td>
			</tr>
		));

		return (
			<>
				<div className="import-versions-error-modal-body">
					<div className="info">
						The following errors were encountered during import, no
						changes were made. Please adjust your spreadsheet
						accordingly and try again.
					</div>
					<table className="import-versions-error basic-table">
						<thead className="header">
							<tr className="headrow">{headingRow}</tr>
						</thead>
						<tbody>{errorRows}</tbody>
					</table>
				</div>
			</>
		);
	}

	function renderFooter() {
		return (
			<>
				<Button
					theme="default"
					onClick={onClose}
				>
					Close
				</Button>
			</>
		);
	}

	const modalProps = {
		title: title || `Error Importing Versions - ${filename}`,
		type: "modal",
		className: "import-versions-error-modal",
		xClose: true,
		allowFullScreen: false,
		setAppTitle: false,
		bladeProps: {
			verticallyCenter: true,
			headerProps: {
				icon: "clearCircle",
				className: "bulk-import-error",
			},
		},

		onClose,
		renderContent,
		renderFooter,
	};

	return <Modal {...modalProps} />;
}

ImportVersionsErrorModal.displayName = "ImportVersionsError";
ImportVersionsErrorModal.propTypes = {
	filename: PropTypes.string,
	errors: PropTypes.array,
	title: PropTypes.string,
};
ImportVersionsErrorModal.defaultProps = {
	filename: "",
	errors: [],
	title: "",
};
